// export const serverUrl = 'https://api.koja-najafabad.ir';
export const serverUrl = 'https://api.koja-najafabad.ir';
// export const serverUrl = "https://api.koja-najafabad.ir";
export const serverApi = serverUrl + "/api/v1/";
export const downloadUrl = serverUrl + "/api/v1/file/";
// export const downloadUrl2 = "http://api.koja-najafabad.ir" + "/api/v1/file/";
export const downloadUrl2 = "http://localhost:2100" + "/api/v1/file/";
export const uploadUrl = serverUrl + "/api/v1/file/upload";
export const uploadUrlRealState = serverUrl + "/api/v1/file/upload/realstate";
export const downloadUrlRealState = serverUrl + "/api/v1/file/realstate";
export const uploadUrlCrocky = serverUrl + "/api/v1/file/crocky";
// export const downloadUrlCrocky = serverUrl + '/api/v1/file/realstate';
// 'https://koja-najafabad.ir'
